import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { i18n, initI18n } from "./vue-i18n";
// tiptapVuetify plugin

import "./plugins/tiptap-vuetify.js";
import "./plugins/navigation-base";

import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import ResponsiveButton from "@/components/util/ResponsiveButton.vue";
Vue.component("r-button", ResponsiveButton);

import LogRocket from "logrocket";

if (location.host.indexOf("localhost") == -1) {
  LogRocket.init("d2dyli/agrify-insights");
}

let initialRoute = "/";
let splitRoute = location.href.split("#");
if (splitRoute && splitRoute.length > 1 && splitRoute[1] != "/") {
  initialRoute = splitRoute[1];
}

// import '../js/jquery-2.1.1.js'
import "../js/aws-sdk-2.776.0.min.js";
import "aws-lex-browser-audio-capture/dist/aws-lex-audio.min.js";
// import '../js/inspinia.js'

AWS.config.region = "us-east-1";
AWS.config.credentials = {
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET,
};

// highcharts
import HighchartsVue from "highcharts-vue";
Vue.filter(
  "numbersWithCommas",
  require("./components/helpers/numbersWithCommas")
);
Vue.use(HighchartsVue);

//google maps
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCTfTFI8mTUANnQfp3hOrQX0EmAbrjKWXo",
    libraries: "places",
  },
});

// drag and drop
Vue.component("vue-draggable-resizable", VueDraggableResizable);

Promise.all([initI18n()]).finally(() => {
  return new Vue({
    router,
    i18n,
    store,
    vuetify,
    data() {
      return {
        timePreference: "11",
        initialRoute,
        eventHub: new Vue(),
      };
    },
    render: (h) => h(App),
  }).$mount("#app");
});
